import React from "react"
import { useTranslation } from "react-i18next"

import { EmptyFilter } from "~/components/FilterWrapper/components/EmptyFilter/EmptyFilter"
import { ShowMore } from "~/components/FilterWrapper/components/ShowMore/ShowMore"
import { FilterWrapper } from "~/components/FilterWrapper/FilterWrapper"
import { Heading } from "~/components/Heading/Heading"
import { Raw } from "~/components/raw"

import { Cell, TopCell } from "./components/Cells/Cells"
import { Filter } from "./components/Filter/Filter"
import styles from "./index.module.css"

export const List: React.FC = () => {
  const { t } = useTranslation()

  return (
    <div className={styles.Wrapper}>
      <Heading as="h2" className={styles.Title} like="h1">
        <Raw html={t("procurements.List.Title")} />
      </Heading>
      <FilterWrapper url={"/procurement/list"}>
        {({ items }) => (
          <>
            <Filter />
            {items.length === 0 ? (
              <EmptyFilter />
            ) : (
              <>
                <TopCell />
                <div className={styles.Cells}>
                  {items.map((item) => (
                    <Cell {...item} key={item.id} />
                  ))}
                </div>
                <ShowMore />
              </>
            )}
          </>
        )}
      </FilterWrapper>
    </div>
  )
}
